const routes = [
  {
    path: '/',
    name: 'Form',
    component: () => import('@/views/form'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/finished',
    name: 'FormFinished',
    component: () => import('@/views/form/form-finished'),
    meta: {
      needLogin: false
    }
  },
  {
    path: '/voyageFinished',
    name: 'voyageFinished',
    component: () => import('@/views/voyage/finished'),
    meta: {
      needLogin: false
    }
  },
  {
    path: '/select-student',
    name: 'SelectStudent',
    component: () => import('@/views/select-student'),
    meta: {
      needLogin: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: {
      needLogin: false
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('@/404'),
    meta: {
      needLogin: false
    }
  }
];

export default routes;
